<template>
<!-- 3张图样式（图片在上方，3张图，第一张图占两个位置） -->
  <div
    id="threePic"
    class="threePic"
    v-bind:style="{backgroundImage:'url(' +'\''+ backgroundPic +'\''+ ')', backgroundRepeat:'no-repeat'}"
  >
  <div class="pic-group">
    <!-- <div class="left"> -->
      <img @click="goLink(tbInfo.link1)" :src="tbInfo.image1"  class="pic large-pic" :class="tbInfo.link1?'link':''"/>
    <!-- </div> -->
    <!-- <div class="right"> -->
      <img @click="goLink(tbInfo.link2)" :src="tbInfo.image2"  class="pic" :class="tbInfo.link2?'link':''"/>
      <img @click="goLink(tbInfo.link3)" :src="tbInfo.image3"  class="pic rightmost" :class="tbInfo.link3?'link':''"/>
    <!-- </div> -->
  </div>
  <div class="bottom-text">
    <div class="left">
      <div class="title">{{tbInfo.title}}</div>
    </div>
    <div class="right">
      <div class="content">{{tbInfo.content}}</div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: "threePic",
  data() {
    return {
      loading: false
    };
  },
  props: ["tbInfo","backgroundPic"],
  methods: {
    // 跳转链接
    goLink(link){
      if(link){
         window.open(link)
      }
    }
  },
  computed: {
  },
  mounted() {
    
  }
};
</script>

<style scoped>
.threePic {
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: cover;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 110px 40px;
  box-sizing: border-box;
}
.rightmost{
  padding-left:0;
}
.pic-group{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0px;
  box-sizing: border-box;
  height: 300px;
  width: 100%;
  margin-top:140px ;
}
/* .pic-group .left{
  flex: 1;
  height: 90%;
}
.pic-group .right{
  flex: 1;
  height: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
} */
.pic-group .large-pic{
  width: 50%;
}
.pic-group  img{
  margin: 10px 10px 10px 0px;
  width: 25%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}
.pic-group .rightmost{
  margin: 10px 0px 10px 0px;
  width: 25%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

.threePic .child-pic{
  flex:1;
  height: 100%;
  display: flex;
  justify-content: center;
}
.threePic .child-pic img{
  padding: 10px;
  width: 465px;
  height: 330px;
  -o-object-fit: cover;
  object-fit: cover;
}
.bottom-text{
  display: flex;
  flex-direction: row;
}
.bottom-text .left{
  position: relative;
  display: flex;
  flex:5;
  /* justify-content: center; */
  height: 300px;
}

.bottom-text .right{
  display: flex;
  flex:13;
  flex-direction: column;
  justify-content: left;
}
.bottom-text .left .title{
  font-size: 30px;
  position: absolute;
  top: 0;
  left:5px;
  font-weight:900;
  color: #222;
  text-align: left;
  margin-top: 40px;
}

.bottom-text .sub-title{
  font-size: 18px;  
  /* white-space: pre; */
  word-break: break-all;
  color: #222;
  margin-top: 10px;
}

.bottom-text .content{
  font-size:18px;
  /* word-break: break-all; */
  margin-top: 10px;
  color: #222;
  white-space: pre-wrap;
}
.threePic .child-pic .link{

  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/comment/tbChildPage/threePic.vue